import { Stack } from "@mantine/core"
import { keepPreviousData } from "@tanstack/react-query"
import { Loader } from "@tfg/ui"

import { HeaderControlsProvider } from "~/components/contexts/useHeaderControlsContext"
import { GetExportRequestsQueryResponse, useGetExportRequests } from "~/gen/api"
import { usePaginatedQuery } from "~/hooks/usePaginatedQuery"
import { ExportRequestsTable } from "~/pages/Brand/DataTransfer/Export/ExortRequestsTable"

export const DataTransferExport = () => {
  const {
    data,
    isPending,
    isFetching,
    totalCount,
    pageBasedPagination,
    setPageBasedPagination,
  } = usePaginatedQuery<
    typeof useGetExportRequests,
    GetExportRequestsQueryResponse
  >(
    useGetExportRequests,
    {},
    {
      query: {
        placeholderData: keepPreviousData,
      },
    }
  )

  return (
    <HeaderControlsProvider>
      <Stack>
        {isPending ? (
          <Loader fullPage />
        ) : (
          <ExportRequestsTable
            data={data?.data ?? []}
            total={totalCount}
            pagination={pageBasedPagination}
            setPagination={setPageBasedPagination}
            isFetching={isFetching}
          />
        )}
      </Stack>
    </HeaderControlsProvider>
  )
}
